import { render } from "./VerifyPendingEmailChange.vue?vue&type=template&id=92ae723c"
import script from "./VerifyPendingEmailChange.vue?vue&type=script&lang=js"
export * from "./VerifyPendingEmailChange.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__